import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/state/language/LanguageProvider';
import { AE_LINK } from './layout/aeTheme';

export interface AeBreadcrumbItem {
  label: string;
  to?: string;
}

interface AeBreadcrumbsProps {
  items: AeBreadcrumbItem[];
}

/** Assessment Engine breadcrumb trail. */
export const AeBreadcrumbs: React.FC<AeBreadcrumbsProps> = ({ items }) => {
  const { t } = useLanguage();

  return (
    <nav aria-label="Breadcrumb" className="text-sm text-[var(--color-secondary-text)] mb-4">
      <ol className="flex flex-wrap items-center gap-1">
        {items.map((item, idx) => (
          <li key={`${item.label}-${idx}`} className="flex items-center gap-1">
            {idx > 0 && <span className="text-[var(--color-secondary-text)]">/</span>}
            {item.to ? (
              <Link to={item.to} className={AE_LINK}>
                {item.label}
              </Link>
            ) : (
              <span className="font-medium text-[var(--color-surface-text)]">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
      <span className="sr-only">{t('assessmentEngine.breadcrumbs.label')}</span>
    </nav>
  );
};
